import {useAppSelector} from '@/hooks';
import {useIsCurrentPageVideo} from '@Hooks/poster-editor/useIsCurrentPageVideo';

export const useIsTimelineButtonVisible = (): boolean => {
  const isCurrentPageVideo = useIsCurrentPageVideo();
  const isTimelineModeActive = useAppSelector((state) => {
    return state.posterEditor.isTimelineModeActive;
  });
  const isVersionHistoryModeActive = useAppSelector((state) => {
    return state.posterEditor.isVersionHistoryModeActive;
  });

  return isCurrentPageVideo && !isTimelineModeActive && !isVersionHistoryModeActive;
};
